import React from 'react';
import propTypes from 'prop-types';
import ConfirmDialog from 'chameleon/packages/blue-book-player/library/modal/ConfirmDialog';

const ReferenceSheetInfoModal = ({ onClose }) => (
  <ConfirmDialog
    size="big"
    title="Reference Sheet"
    aria={{
      'aria-live': 'polite',
    }}
    content={{
      btnPrimary: 'Close',
    }}
    onClose={onClose}
    onSuccess={onClose}
  >
    <h4 className="text-4xl font-bold mt-0">Reference Sheet Coming Soon</h4>
    <p>
      You will have access to a reference sheet on your AP Exam. It will be
      available here soon.
    </p>
  </ConfirmDialog>
);

ReferenceSheetInfoModal.propTypes = {
  onClose: propTypes.func.isRequired,
};

export default ReferenceSheetInfoModal;
